import { nameofFactory } from "utils/nameof";
import {
  type SurveyQuestion,
  type OtherAnswerOptions,
  type SurveyQuestionOtherAnswerOptionsProps,
} from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import styles from "features/Library/Surveys/SurveyDetails/SurveyContentForm/SurveyFields/SurveyQuestionOtherAnswerOptions/SurveyQuestionOtherAnswerOptions.module.scss";
import React from "react";
import { Checkbox } from "features/Library/Common/QuestionsForm/Questions/QuestionFields/CheckBox/Checkbox";
import { RemoveButton } from "features/Library/Common/QuestionsForm/RemoveButton/RemoveButton";

export const SurveyQuestionOtherAnswerOptions = (props: SurveyQuestionOtherAnswerOptionsProps) => {
  const { onChanged, onRemove, otherAnswerOptions, propertyNamePrefix, validatedFieldProps, disabled } = props;
  const otherAnswerText = "Other";

  const questionNameOf = nameofFactory<SurveyQuestion<any>>();
  const optionsNameOf = nameofFactory<OtherAnswerOptions>();

  return (
    <div className={styles.container} aria-label={"Other answer configuration"}>
      <div className={styles.options}>
        <div className={styles.text}>{otherAnswerText}</div>
        <Checkbox
          validatedFieldProps={validatedFieldProps}
          label={"Include Text Field for User"}
          onChanged={onChanged}
          propertyName={`${propertyNamePrefix}${questionNameOf("otherAnswerOptions")}.${optionsNameOf(
            "includeUserTextField",
          )}`}
          isChecked={otherAnswerOptions.includeUserTextField}
          tooltip={'Allows end-user to enter additional text when "Other" is selected as an answer'}
          disabled={disabled}
        />
      </div>

      {disabled || <RemoveButton onClick={onRemove} />}
    </div>
  );
};
